<div class="team-subteams-container py-12" *ngIf="(teamService.teamSubTeams$ | async).length || hasSearched">
    <div fxLayoutAlign="space-between center">
        <h2 class="my-16">{{ 'TEAMS.SUBTEAM.TITLE' | translate }} ({{ teamSubTeamsTotalCount$ | async }})</h2>

        <div fxLayout="row" fxLayoutAlign="end center">
            <app-search-outline class="mr-8" [searchInput]="searchInput"></app-search-outline>
            <app-flat-button [icon]="'add'" [label]="'TEAMS.BUTTON.CREATE_NEW_SUBTEAM'" (onClick)="openCreateNewSubTeamDialog()" *ngIf="canManageSubteams"></app-flat-button>
        </div>
    </div>

    <div class="team-subteams mt-8" *ngIf="(teamService.teamSubTeams$ | async).length; else noResults">
        <div class="mb-8" *ngFor="let team of teamService.teamSubTeams$ | async">
            <div class="team-card-container">
                <div class="team-card-progress-container">
                    <div fxLayout="column" fxLayout.gt-md="row" class="team-card-progress p-16">
                        <div fxLayout="column" fxLayout.gt-xs="row" [fxFlex.gt-md]="team.charts.length ? '1 0 calc(60% - 12px)' : '1 0 calc(40% - 24px)'">
                            <div
                                fxLayout="column"
                                fxLayoutAlign="space-between flex-start"
                                class="team-info-container mr-12 mb-12"
                                fxFlex.gt-xs="1 0 calc(70% - 12px)"
                                fxFlex.gt-md="1 0 calc(60% - 12px)"
                                (click)="navigateToTeamDetailsPage(team)"
                            >
                                <div class="w-100-p">
                                    <div fxLayout="row" fxLayoutAlign="space-between center">
                                        <div fxLayout="row" fxLayoutAlign="flex-start center" class="mb-12">
                                            <div class="custom-avatar-icon gray mr-8" fxLayoutAlign="center center">
                                                <mat-icon svgIcon="team"></mat-icon>
                                            </div>
                                            <div fxLayout="column">
                                                <h3 class="m-0">{{ team.name }}</h3>
                                                <div fxLayout="row">
                                                    <ng-container *ngFor="let teamBreadcrumb of team.breadcrumbs">
                                                        <div fxLayout="row" *ngIf="teamBreadcrumb !== team.breadcrumbs[team.breadcrumbs.length - 1]" class="breadcrumbs-container">
                                                            <span fxLayout="row" fxLayoutAlign="start center">
                                                                <span
                                                                    [class.pointer]="teamBreadcrumb.isClickable"
                                                                    (click)="navigateToTeam(teamBreadcrumb); $event.stopPropagation()"
                                                                >
                                                                    {{ teamBreadcrumb.name }}
                                                                </span>
                                                                <span class="mx-4" *ngIf="!isLast && team.breadcrumbs.indexOf(teamBreadcrumb) !== team.breadcrumbs.length - 2">
                                                                    /
                                                                </span>
                                                            </span>
                                                        </div>
                                                    </ng-container>
                                                </div>
                                            </div>
                                        </div>

                                        <div fxLayout="row">
                                            <div fxLayout="row" (click)="getTeamWatchers(team.id, menuTrigger); $event.preventDefault()" class="pointer mr-8">
                                                <app-white-button
                                                    [icon]="'visibility'"
                                                    [label]="team.watcherCount"
                                                    class="no-pointer-events see-more mr-8"
                                                    aria-label="See watchers"
                                                    #menuTrigger="matMenuTrigger"
                                                    [matMenuTriggerFor]="seeWatchers"
                                                >
                                                </app-white-button>
                                            </div>

                                            <mat-menu #seeWatchers="matMenu" class="watchers-menu" xPosition="before">
                                                <div fxLayout="column" *ngIf="(teamService.teamWatchers$ | async).length; else noTeamWatchers">
                                                    <button mat-menu-item aria-label="add" (click)="stopWatchingTeam(team)" *ngIf="team.isCurrentUserWatcher">
                                                        <mat-icon class="mr-8">visibility_off</mat-icon>
                                                        <span>{{ 'TEAMS.WATCHER.BUTTON.STOP_WATCHING' | translate }}</span>
                                                    </button>

                                                    <button mat-menu-item aria-label="add" (click)="startWatchingTeam(team)" *ngIf="!team.isCurrentUserWatcher">
                                                        <mat-icon class="mr-8">visibility</mat-icon>
                                                        <span>{{ 'TEAMS.WATCHER.BUTTON.START_WATCHING' | translate }}</span>
                                                    </button>

                                                    <span class="px-16 pt-12 pb-8 font-medium">{{ 'TEAMS.WATCHER.TITLE.PLURAL' | translate }}</span>

                                                    <div
                                                        mat-menu-item
                                                        (click)="$event.stopPropagation()"
                                                        fxLayout="row"
                                                        fxLayoutAlign="space-between center"
                                                        *ngFor="let teamWatcher of teamService.teamWatchers$ | async"
                                                    >
                                                        <div fxLayout="row" fxLayoutAlign="flex-start center">
                                                            <img
                                                                class="avatar pointer"
                                                                *ngIf="teamWatcher.avatar.src; else initials"
                                                                [alt]="teamWatcher.fullName"
                                                                [src]="teamWatcher.avatar.src"
                                                            />
                                                            <ng-template #initials>
                                                                <div fxLayoutAlign="center center" class="avatar-initials avatar">{{ teamWatcher.fullName | initials }}</div>
                                                            </ng-template>
                                                            <span class="m-0">{{ teamWatcher.fullName }}</span>
                                                        </div>
                                                        <mat-icon
                                                            class="mr-0 remove-icon"
                                                            (click)="openRemoveTeamWatcherDialog(teamWatcher, team); menuTrigger.closeMenu()"
                                                            *ngIf="team.isCurrentUserLeader || team.isCurrentUserTeamLeaderSubteams"
                                                            >close</mat-icon
                                                        >
                                                    </div>
                                                </div>

                                                <ng-template #noTeamWatchers>
                                                    <div fxLayout="column" fxLayoutAlign="center center">
                                                        <mat-icon class="participant-view-illustration" svgIcon="members_illustration"> </mat-icon>
                                                        <p class="mt-8 mb-12">
                                                            {{ 'TEAMS.WATCHER.LABEL.NO_WATCHERS_YET' | translate }}
                                                        </p>
                                                    </div>
                                                </ng-template>
                                                <button
                                                    mat-menu-item
                                                    aria-label="add"
                                                    (click)="openAddUserToTeamDialog(team, UserTeamRoleEnum.WATCHER)"
                                                    *ngIf="team.isCurrentUserLeader || team.isCurrentUserTeamLeaderSubteams"
                                                >
                                                    <mat-icon class="mr-8">add</mat-icon>
                                                    <span>{{ 'TEAMS.WATCHER.BUTTON.ADD_WATCHER' | translate }}</span>
                                                </button>
                                            </mat-menu>
                                        </div>
                                    </div>

                                    <div class="mb-40">
                                        <span>{{ team.memberCount }} {{ (team.memberCount > 1 ? 'TEAMS.MEMBER.PLURAL' : 'TEAMS.MEMBER.SINGULAR') | translate }}</span>
                                    </div>
                                </div>

                                <div class="w-100-p" fxLayout="row wrap" fxLayoutAlign="space-between">
                                    <div fxLayout="column" fxLayoutAlign="flex-start">
                                        <span class="mb-12">{{ 'TEAMS.LEAD.LABEL.LEADS' | translate }}</span>

                                        <div fxLayout="row" *ngIf="team.leaders.length; else noLeads">
                                            <div *ngFor="let user of team.leaders" class="relative">
                                                <img class="avatar mr-4" *ngIf="user.avatar.src; else initials" [alt]="user.fullName" [src]="user.avatar.src" />
                                                <ng-template #initials>
                                                    <div fxLayoutAlign="center center" class="avatar-initials avatar">{{ user.fullName | initials }}</div>
                                                </ng-template>
                                                <ng-template [onlineStateIndicator]="user.isOnline"> </ng-template>
                                            </div>
                                        </div>
                                        <ng-template #noLeads>&#8212;</ng-template>
                                    </div>

                                    <div fxLayout="column" fxLayoutAlign="flex-end" *ngIf="canNavigateToSubteamDetails(team)">
                                        <app-white-button [label]="'GENERAL.BUTTON.SEE_MORE'"></app-white-button>
                                    </div>
                                </div>
                            </div>

                            <mat-card
                                appearance="outlined"
                                fxLayout="row"
                                fxLayoutAlign="flex-start space-between"
                                fxFlex.gt-xs="1 0 calc(30% - 12px)"
                                fxFlex.gt-lg="1 0 calc(14% - 12px)"
                                class="p-0 mb-12 team-progress-card-container course-completion-state no-margin-bottom mat-elevation-z0"
                                *ngIf="team.charts.length"
                            >
                                <app-course-completion class="w-100-p" [charts]="team.charts"></app-course-completion>
                            </mat-card>
                        </div>

                        <div fxLayout="column" fxLayoutAlign="flex-start space-between" fxFlex.gt-md="1 0 calc(40% - 12px)" *ngIf="team.charts.length; else noTeamProgress">
                            <div fxLayout="column" fxLayout.gt-xs="row" fxFlex="1 0 100%">
                                <mat-card
                                    appearance="outlined"
                                    fxLayout="row"
                                    fxLayoutAlign="flex-start space-between"
                                    fxFlex="0 1 100%"
                                    class="mb-12 p-0 team-progress-card-container active-days mat-elevation-z0"
                                >
                                    <app-active-days class="w-100-p" [team]="team"></app-active-days>
                                </mat-card>

                                <mat-card
                                    appearance="outlined"
                                    fxLayout="row"
                                    fxLayoutAlign="flex-start space-between"
                                    fxFlex="0 1 100%"
                                    class="p-0 team-progress-card-container mat-elevation-z0"
                                >
                                    <app-average-learning-time class="w-100-p" [horizontalView]="false" [avgLearningTime]="team.avgLearningTime"></app-average-learning-time>
                                </mat-card>
                            </div>
                        </div>

                        <ng-template #noTeamProgress>
                            <div class="no-team-progress p-12" fxLayout="column" fxLayoutAlign="start space-between" fxFlex.gt-md="1 0 60%" fxFlex.gt-lg="1 0 51%">
                                <div fxLayout="column" fxLayout.gt-xs="row" fxLayoutAlign="center center" fxFlex="1 0 100%">
                                    <mat-icon class="participant-view-illustration" svgIcon="team_progress_illustration"></mat-icon>
                                    <div fxLayout="column" class="no-team-progress-description">
                                        <h3 class="mt-8 mb-4">{{ 'TEAMS.TEAM_PROGRESS.LABEL.NO_PROGRESS_YET' | translate }}</h3>
                                        <p class="mt-0 mb-16" *ngIf="!team.memberCount">
                                            {{
                                                (team.isCurrentUserLeader || team.isCurrentUserTeamLeaderSubteams
                                                    ? 'TEAMS.TEAM_PROGRESS.LABEL.ADD_MEMBERS_TO_SEE_PROGRESS'
                                                    : 'TEAMS.TEAM_PROGRESS.LABEL.SHOW_PROGRESS'
                                                ) | translate
                                            }}
                                        </p>
                                    </div>
                                    <div fxLayoutAlign="end start" fxFlex="none" *ngIf="(team.isCurrentUserLeader || team.isCurrentUserTeamLeaderSubteams) && !team.memberCount">
                                        <app-flat-button
                                            [icon]="'add'"
                                            [label]="'TEAMS.MEMBER.BUTTON.ADD_MEMBER'"
                                            (onClick)="openAddUserToTeamDialog(team, UserTeamRoleEnum.MEMBER)"
                                        ></app-flat-button>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </div>
                </div>
            </div>
        </div>

        <app-white-button
            *ngIf="(teamService.teamSubTeams$ | async).length < (teamSubTeamsTotalCount$ | async)"
            [label]="'GENERAL.LABEL.LOAD_MORE'"
            [fullWidth]="true"
            [isLoading]="teamSubTeamsLoading$ | async"
            (onClick)="loadMoreSubTeams()"
            style="height: 36px"
        ></app-white-button>
    </div>

    <ng-template #noResults>
        <div class="team-subteams empty-state-container-modern my-0 mx-auto" fxLayout="column" fxLayoutAlign="center center">
            <mat-icon class="participant-view-illustration" svgIcon="search_no_results_modern"></mat-icon>
            <h3>{{ 'GENERAL.LABEL.NO_RESULTS_FOUND' | translate }}</h3>
            <p>{{ 'GENERAL.MESSAGE.SEARCH_NO_RESULTS' | translate }}</p>
        </div>
    </ng-template>
</div>
